import { useEffect } from 'react';

const OP_PLUS_EXTERNAL_TOAST = '.optoast';
export const OP_PLUS_ADDED_HASH = 'plusadded';
const OP_PLUS_TOAST_DELAY = 8000;

export const showPlusAddedToast = (toast: HTMLElement) => {
  toast && toast.classList.add('show');
};

export const hidePlusAddedToast = (toast: HTMLElement) => {
  if (!toast) return;

  setTimeout(() => {
    toast.classList.remove('show');
  }, OP_PLUS_TOAST_DELAY);
};

export const showAndHideToast = () => {
  const toast = document.querySelector(OP_PLUS_EXTERNAL_TOAST) as HTMLElement;
  if (!toast) return;
  showPlusAddedToast(toast);
  hidePlusAddedToast(toast);
};

const OpPlusAddedNotification = () => {
  const showPlusAddedToastOnPageLoad = () => {
    if (!window.location.hash.includes(OP_PLUS_ADDED_HASH)) {
      return;
    }
    showAndHideToast();
  };

  useEffect(() => {
    showPlusAddedToastOnPageLoad();
  }, []);

  return null;
};
export default OpPlusAddedNotification;
